import { render, staticRenderFns } from "./update-account-hold.component.vue?vue&type=template&id=2b821844&"
import script from "./update-account-hold.component.vue?vue&type=script&lang=ts&"
export * from "./update-account-hold.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports